export default "__VITE_ASSET__DYA5ITmk__"